export const customParamsHitSearchScope = [
  'unlocked_eligibility',
  'searches',
  'ticket_type',
  'trip_type',
  'trip_dates',
  'location',
  'class_type',
  'hotel_dates',
  'trip_distance',
  'arrival_city_code',
  'departure_city_code',
  'transaction_price',
  'carrier_trip_number',
  'selection_type',
  'provider_product',
  'low_co2',
  'buypath',
  'dynamic_funnel',
] as const;

export const customParamsHitFlowScope = [
  'provider',
  'bundle_ID',
  'booking_status',
  'page_category',
  'booking_id',
  'smart_funnel_productstoskip',
] as const;

export const customParamsHitScope = [
  ...customParamsHitSearchScope,
  ...customParamsHitFlowScope,
  'site_type',
  'release_number',
  'mkttrack',
  'mktsession_id',
  'r_marketing_split',
  'app_traffic',
  'wapbx_exp',
  'connection_type',
  'touchpoint',
  'url',
  'car_price_split',
  'full_referrer',
  'misc',
  'checked_booking_id',
  'subscription_type',
  'subscription_prime_mode',
  'prime_autorenewal_status',
  'beta',
  'hit_type',
  'sso_hit',
  'screen_name',
  'affiliation',
  'coupon',
  'event_action',
  'event_category',
  'event_label',
  'edo_timestamp',
  'edo_campaign_code',
] as const;

export const customMetrics = [
  'number_of_passengers',
  'number_of_adults',
  'number_of_children',
  'number_of_infants',
  'duration',
  'number_of_rooms_in_dp',
  'days_in_advanced',
  'gross_sale',
] as const;

export const customParamsProduct = [
  'departure_date',
  'arrival_date',
  'payment_method',
  'product_code',
  'transport_code',
] as const;

export const legacyMetricsHit = [
  'metric1',
  'metric2',
  'metric3',
  'metric4',
  'metric5',
  'metric6',
  'metric7',
  'metric8',
] as const;

export const legacyDimensionsHitSearchScope = [
  'dimension32',
  'dimension38',
  'dimension42',
  'dimension43',
  'dimension44',
  'dimension45',
  'dimension46',
  'dimension47',
  'dimension48',
  'dimension51',
  'dimension52',
  'dimension54',
  'dimension61',
  'dimension68',
  'dimension70',
  'dimension72',
  'dimension73',
  'dimension77',
] as const;

export const legacyDimensionsHitFlowScope = [
  'dimension56',
  'dimension57',
  'dimension64',
  'dimension35',
  'dimension89',
] as const;

export const legacyDimensionsHitScope = [
  ...legacyDimensionsHitSearchScope,
  ...legacyDimensionsHitFlowScope,
  'dimension9',
  'dimension13',
  'dimension33',
  'dimension39',
  'dimension41',
  'dimension49',
  'dimension50',
  'dimension58',
  'dimension60',
  'dimension62',
  'dimension63',
  'dimension69',
  'dimension74',
  'dimension87',
  'dimension88',
  'dimension53',
  'dimension14',
  'dimension78',
  'dimension56',
] as const;

export const legacyDimensionsProduct = [
  'dimension2',
  'dimension3',
  'dimension4',
  'dimension5',
  'dimension6',
] as const;
